import React, { useState } from 'react';
import { Modal, Checkbox, Span } from '@salecycle/ui-component-library';
import { useTranslation } from 'react-i18next';

export interface RcsRandomiseSnapshotModalProps {
  isOpen: boolean;
  onClose: () => void;
  onContinue: (dontShowAgain: boolean) => void;
}

export const RcsRandomiseSnapshotModal: React.FC<RcsRandomiseSnapshotModalProps> = ({
  isOpen,
  onClose,
  onContinue,
}) => {
  const { t } = useTranslation(['designs']);
  const [dontShowAgain, setDontShowAgain] = useState(false);

  const handleContinue = () => {
    onContinue(dontShowAgain);
    onClose();
    setDontShowAgain(false);
  };

  const handleClose = () => {
    setDontShowAgain(false);
    onClose();
  };

  return (
    <div data-testid="RcsRandomiseSnapshotModal">
      <Modal
        heading={t('designs:rcsTemplateEditor.snapshotTab.randomiseModal.heading')}
        variation="clean"
        isOpen={isOpen}
        onCloseButtonClicked={handleClose}
        onOkButtonClicked={handleContinue}
        okButtonLabel={t('designs:rcsTemplateEditor.snapshotTab.randomiseModal.continue')}
        okButtonType="primary"
        customFooter={
          <Checkbox
            id="rcs-randomise-dont-show-again"
            label={t('designs:rcsTemplateEditor.snapshotTab.randomiseModal.dontShowAgain')}
            checked={dontShowAgain}
            onChange={setDontShowAgain}
            data-testid="RcsRandomiseSnapshotModalDontShowAgain"
          />
        }
      >
        <Span>{t('designs:rcsTemplateEditor.snapshotTab.randomiseModal.description')}</Span>
      </Modal>
    </div>
  );
};
